<template>
  <div style="width:350px" v-loading="fullscreenLoading">
    <el-form autocomplete="off" size="mini" :model="formInlinezin" :rules="rules" ref="formInlinezin" label-width="100px" class="demo-ruleForm" :inline="true">
      <el-row>
        <el-col>
          <el-form-item label="手机号" prop="mobileNo" style="margin-top:16px">
            <el-input v-model="formInlinezin.mobileNo" clearable maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="smsValidCode">
            <el-input v-model="formInlinezin.smsValidCode" clearable style="width:120px;margin-right:5px;"></el-input>
            <div v-show="show" class="verification">
              <span @click="getCode" style="cursor:pointer;">{{code}}</span>

            </div>
            <div v-show="!show" class="verification" style="background-color:#bfbcbc;color:#fff;">
              <span>{{count}}秒</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div style="padding-left:120px;margin-top:10px">
          <el-button type="primary" @click="submitForm('formInlinezin')">确认修改</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
    data() {
        return {
            fullscreenLoading: false,
            show: true,
            count: "",
            timer: null,
            code: "发送验证码",
            formInlinezin: {},
            rules: {
                smsValidCode: [
                    { required: true, message: "请输入验证码", trigger: "blur" }
                ],
                mobileNo: [
                    {
                        required: true,
                        message: "请填写手机号",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    methods: {
        getCode() {
            if (this.formInlinezin.mobileNo == "") {
                this.$message.error("请填写手机号");
            } else if (!/^1[0-9]\d{9}$/.test(this.formInlinezin.mobileNo)) {
                this.$message.error("请填写正确的手机号");
                return false;
            } else {
                this.$http
                    .post(`/w/sms/sendValidCode`, {
                        mobileNo: this.formInlinezin.mobileNo,
                        tokenId: localStorage.getItem("tokenId")
                    })
                    .then(data => {
                        this.fullscreenLoading = false;
                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.show = false;
                            this.timer = setInterval(() => {
                                if (
                                    this.count > 0 &&
                                    this.count <= TIME_COUNT
                                ) {
                                    this.count--;
                                } else {
                                    this.show = true;
                                    this.code = "重新发送";
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000);
                        }
                    })
                    .catch(error => {
                        this.fullscreenLoading = false;
                    });
            }
        },
        submitForm() {
            this.$http
                .post("/w/user/modifyMobile", {
                    mobileNo: this.formInlinezin.mobileNo,
                    smsValidCode: this.formInlinezin.smsValidCode,
                    tokenId: localStorage.getItem("tokenId")
                })
                .then(
                    data => {
                        this.$message({
                            message: "修改手机号成功",
                            type: "success"
                        });
                        this.$refs["formInlinezin"].resetFields();
                        this.fullscreenLoading = false;
                    },
                    err => {
                        this.fullscreenLoading = false;
                    }
                );
        }
    }
};
</script>

<style scoped>
.verification {
    width: 80px;
    height: 30px;
    background: #409eff;
    font-size: 12px;
    border-radius: 3px;
    line-height: 30px;
    text-align: center;
    color: white;
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/view/page/editphone/editphone.vue